import { DateHelper } from "apps/idl/src/helpers";
import { ConfigData } from "apps/idl/src/model";
import { ITarifLettreCle } from "../model/ITarifLettreCle";

export class TarifHelper {
	static getFiltreTarifLettreCleParDate(tar: ITarifLettreCle, dateAComparer: number | Date): boolean {
			const compDateDebut = tar.dateDebut ? DateHelper.compareTwoDates(dateAComparer, tar.dateDebut) : 0;
			const compDateFin = tar.dateFin ? DateHelper.compareTwoDates(dateAComparer, tar.dateFin) : -1;
			return tar.zoneGeographique == ConfigData.geoZoneApp
					&& (compDateDebut > 0 || compDateDebut == 0)
					&& compDateFin < 0;
	}
}